import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'

/**
 * 2.0接口升级
 * 2.0接口前端和mi server 直接对接，前端不和smileone直接对接
 */

// 获取游戏套餐列表
export const getPackageList = (game = '') => {
  return request.get({
    url: `/api/admin/config/bundle/list?game=${game}`,
  })
}

// 获取游戏支付渠道列表
export const getPaymentList = (game = '') => {
  return request.get({
    url: `/api/admin/config/payment/list?game=${game}`,
  })
}

/**
 * freefire 进行uid的校验
 * @param {*} options
 * user_id: 用户id
 * gamename: 游戏名称
 */
export const check_uid = (uid, gameName = 'freefire', showLoading) => {
  return request.post(
    {
      url: '/api/order/user/check',
      data: {
        user_id: uid,
        gamename: gameName,
        time: Date.now(),
      },
    },
    {
      showLoading: !!showLoading,
      showErrorToast: false,
    }
  )
}

export const checkUid = (options, configs) => {
  const { showLoading = false, showErrorToast = false } = configs || {}
  return request.postJson(
    {
      url: appendApiUrl('/order/check/user'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading,
      showErrorToast,
    }
  )
}
/**
 *
 * 之后的所有的CP都走一个接口【统一接口校验CP Uid】
 */

export const unifiedCheckUid = (options, configs) => {
  const { showLoading = true, showErrorToast = true } = configs || {}
  return request.postJson(
    {
      url: appendApiUrl('/cp-interact/check-user'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading,
      showErrorToast,
    }
  )
}
